<template>
  <div :id="id" class="modal px-0" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content border-0 mx-3">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal',
  props: ['id']
}
</script>

<style>
.modal-dialog {
  width: 100% !important;
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/modal/Modal.vue